import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { z } from 'zod';
import { GenericUserID } from './models.generic';

extendZodWithOpenApi(z);

export const UserFullnameSchema = z
  .string()
  .describe('The TIC `user.name`')
  .openapi({ example: 'John Doe' });

export const UserProfileSchema = z.object({
  id: GenericUserID,
  name: UserFullnameSchema.nullable(), // should probably be required
  timely_id: z.number().nullable().describe('The Timely `user.id`').openapi({ example: 100 }),
  avatar_url: z.string().url().optional().nullable(),
});

export type UserProfile = z.infer<typeof UserProfileSchema>;

export const PutUserProfileSchema = UserProfileSchema.pick({
  name: true,
  avatar_url: true,
}).extend({
  email: z.string().email().optional().openapi({
    example: 'foo@bar.com',
    description:
      'The new email address. When supplied, will trigger an email on both the old and new email address.',
  }),
});

export type PutUserProfile = z.infer<typeof PutUserProfileSchema>;
